import { Tween, Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import ElementComponent from '../../../Component/UI/Element';
import { delay } from '../../../Utility/Task/TaskQueue';
import { DEFAULT_CARD_SCALE } from '../../../Component/Level/Card';

interface IPulseMeta {
    delay?: number;
    targetScale?: number;
    amplitude?: number;
    repeat?: number;
     [key: string]: any;
}

export class Pulse extends AnimationClip<IPulseMeta> {
    public *execute(
        gameObject: GameObject,
        meta?: IPulseMeta
    ): IterableIterator<number> {
        const repeat = meta?.repeat ?? 3;
        let component: TransformComponent | ElementComponent;
        if (gameObject.hasComponent(TransformComponent)) {
            component = gameObject.getComponent(TransformComponent);
        } else if (gameObject.hasComponent(ElementComponent)) {
            component = gameObject.getComponent(ElementComponent);
        }

        if (meta?.delay) {
            yield* delay(meta.delay);
        }

        const { targetScale = DEFAULT_CARD_SCALE, amplitude = 0.1} = meta ?? {};
        const tweenDelay: number = 200;
        const scale1 = targetScale * (1 - amplitude);
        const scale2 = targetScale * (1 + amplitude);
        const scaleT = targetScale;

        const tween: Tween = this.getTween(component.scale);
        tween.easing(Easing.Cubic.InOut);

        for (let i = 0; i < repeat; i++) {
            yield* this.tweenTo(tween, scale2, tweenDelay);
            yield* this.tweenTo(tween, scale1, tweenDelay);
        }

        yield* this.tweenTo(tween, scaleT, tweenDelay);
    }

    private *tweenTo(
        tween: Tween,
        scale: number,
        delay: number
    ): IterableIterator<number> {
        tween.to({ x: scale, y: scale }, delay);
        yield* this.startTween(tween);
    }
}
